exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n.distpicker-address-wrapper {\n  color: #9caebf;\n}\n.distpicker-address-wrapper .el-select {\n    width: 30%;\n}\n", ""]);

// exports
exports.locals = {
	"xrColorPrimary": "#2362FB"
};